<template>
  <svg
    v-if="isEmpty"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.37469 14.8542L9.99969 13.2708L12.6247 14.875L11.9372 11.875L14.2497 9.875L11.208 9.60417L9.99969 6.77083L8.79136 9.58333L5.74969 9.85417L8.06219 11.875L7.37469 14.8542ZM9.99969 15.2292L6.54136 17.3125C6.38858 17.4097 6.22886 17.4514 6.06219 17.4375C5.89553 17.4236 5.74969 17.3681 5.62469 17.2708C5.49969 17.1736 5.40247 17.0522 5.33303 16.9067C5.26358 16.7606 5.24969 16.5972 5.29136 16.4167L6.20803 12.4792L3.14553 9.83333C3.00664 9.70833 2.91997 9.56583 2.88553 9.40583C2.85053 9.24639 2.8608 9.09028 2.91636 8.9375C2.97191 8.78472 3.05525 8.65972 3.16636 8.5625C3.27747 8.46528 3.43025 8.40278 3.62469 8.375L7.66636 8.02083L9.22886 4.3125C9.2983 4.14583 9.40608 4.02083 9.55219 3.9375C9.69775 3.85417 9.84692 3.8125 9.99969 3.8125C10.1525 3.8125 10.3019 3.85417 10.448 3.9375C10.5936 4.02083 10.7011 4.14583 10.7705 4.3125L12.333 8.02083L16.3747 8.375C16.5691 8.40278 16.7219 8.46528 16.833 8.5625C16.9441 8.65972 17.0275 8.78472 17.083 8.9375C17.1386 9.09028 17.1491 9.24639 17.1147 9.40583C17.0797 9.56583 16.9927 9.70833 16.8539 9.83333L13.7914 12.4792L14.708 16.4167C14.7497 16.5972 14.7358 16.7606 14.6664 16.9067C14.5969 17.0522 14.4997 17.1736 14.3747 17.2708C14.2497 17.3681 14.1039 17.4236 13.9372 17.4375C13.7705 17.4514 13.6108 17.4097 13.458 17.3125L9.99969 15.2292Z"
      fill="#ADADAD"
    />
  </svg>
  <svg
    v-else-if="isFilled"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99969 14.3962L6.54136 16.4795C6.38858 16.5767 6.22886 16.6184 6.06219 16.6045C5.89553 16.5906 5.74969 16.535 5.62469 16.4378C5.49969 16.3406 5.40247 16.2192 5.33303 16.0737C5.26358 15.9275 5.24969 15.7642 5.29136 15.5837L6.20803 11.6462L3.14553 9.00033C3.00664 8.87533 2.91997 8.73283 2.88553 8.57283C2.85053 8.41338 2.8608 8.25727 2.91636 8.10449C2.97191 7.95171 3.05525 7.82671 3.16636 7.72949C3.27747 7.63227 3.43025 7.56977 3.62469 7.54199L7.66636 7.18783L9.22886 3.47949C9.2983 3.31283 9.40608 3.18783 9.55219 3.10449C9.69775 3.02116 9.84692 2.97949 9.99969 2.97949C10.1525 2.97949 10.3019 3.02116 10.448 3.10449C10.5936 3.18783 10.7011 3.31283 10.7705 3.47949L12.333 7.18783L16.3747 7.54199C16.5691 7.56977 16.7219 7.63227 16.833 7.72949C16.9441 7.82671 17.0275 7.95171 17.083 8.10449C17.1386 8.25727 17.1491 8.41338 17.1147 8.57283C17.0797 8.73283 16.9927 8.87533 16.8539 9.00033L13.7914 11.6462L14.708 15.5837C14.7497 15.7642 14.7358 15.9275 14.6664 16.0737C14.5969 16.2192 14.4997 16.3406 14.3747 16.4378C14.2497 16.535 14.1039 16.5906 13.9372 16.6045C13.7705 16.6184 13.6108 16.5767 13.458 16.4795L9.99969 14.3962Z"
      fill="#FFED00"
    />
  </svg>
  <svg
    v-else
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.37469 14.8542L9.99969 13.2708L12.6247 14.875L11.9372 11.875L14.2497 9.875L11.208 9.60417L9.99969 6.77083L8.79136 9.58333L5.74969 9.85417L8.06219 11.875L7.37469 14.8542ZM9.99969 15.2292L6.54136 17.3125C6.38858 17.4097 6.22886 17.4514 6.06219 17.4375C5.89553 17.4236 5.74969 17.3681 5.62469 17.2708C5.49969 17.1736 5.40247 17.0522 5.33303 16.9067C5.26358 16.7606 5.24969 16.5972 5.29136 16.4167L6.20803 12.4792L3.14553 9.83333C3.00664 9.70833 2.91997 9.56583 2.88553 9.40583C2.85053 9.24639 2.8608 9.09028 2.91636 8.9375C2.97191 8.78472 3.05525 8.65972 3.16636 8.5625C3.27747 8.46528 3.43025 8.40278 3.62469 8.375L7.66636 8.02083L9.22886 4.3125C9.2983 4.14583 9.40608 4.02083 9.55219 3.9375C9.69775 3.85417 9.84692 3.8125 9.99969 3.8125C10.1525 3.8125 10.3019 3.85417 10.448 3.9375C10.5936 4.02083 10.7011 4.14583 10.7705 4.3125L12.333 8.02083L16.3747 8.375C16.5691 8.40278 16.7219 8.46528 16.833 8.5625C16.9441 8.65972 17.0275 8.78472 17.083 8.9375C17.1386 9.09028 17.1491 9.24639 17.1147 9.40583C17.0797 9.56583 16.9927 9.70833 16.8539 9.83333L13.7914 12.4792L14.708 16.4167C14.7497 16.5972 14.7358 16.7606 14.6664 16.9067C14.5969 17.0522 14.4997 17.1736 14.3747 17.2708C14.2497 17.3681 14.1039 17.4236 13.9372 17.4375C13.7705 17.4514 13.6108 17.4097 13.458 17.3125L9.99969 15.2292Z"
      fill="#FFED00"
    />
  </svg>
</template>

<script>
export default {
  name: "IconStar",

  props: {
    isFilled: {
      type: Boolean,
      default: false,
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
